import React from "react";
import Navbar from "./Navbar";
import PageTitle from './components/PageTitle';


const AdminDashboard = () => (
  <div>
    <PageTitle title="Admin Dashboard" description="Administrative dashboard for system management" />
    <Navbar pageTitle="Admin Dashboard" />
    <div className="container py-4">
      <h2>Welcome, Administrative Assistant!</h2>
      <p>This is your dashboard.</p>
    </div>
  </div>
);

export default AdminDashboard; 